import classnames from 'classnames';
import * as React from 'react';
import { Theme } from './constants';
import './styles/Toolbar.scss';

type ToolbarProps = React.PropsWithChildren<{
    className?: string;
    theme: Theme;
    isNewDesktopNav?: boolean;
}>;

function Toolbar({
    children,
    className,
    isNewDesktopNav,
    theme = 'light',
}: ToolbarProps) {
    const classes = classnames(
        'palette-toolbar',
        className,
        `palette-toolbar--${theme}`,
        { 'palette-toolbar--new-nav': isNewDesktopNav },
    );

    return (
        <div className={classes}>
            {children}
        </div>
    );
}

export default Toolbar;
